export default __webpack_public_path__ + "d76ac97f523062e8e8a6835ccf83d83f.png";